import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IPaginatedResponse } from "../models/api/paginated-response";
import { IContact } from "../models/contact/contact";
import { IContactsSearchParams } from "../models/contact/contacts-search-params";
import { IDeleteContactSearchParams } from "../models/contact/delete-contact-search-params";
import { IUpdateContactPayload } from "../models/contact/update-contact-payload";

@Injectable({ providedIn: "root" })
export class ContactService {
  constructor(private readonly _httpClient: HttpClient) {}

  create(payload: IContact) {
    return this._httpClient.post<void>(this.withBaseUrl(), payload);
  }

  getAll(params: IContactsSearchParams) {
    return this._httpClient.get<IPaginatedResponse<IContact>>(this.withBaseUrl("/all"), { params });
  }

  update(payload: IUpdateContactPayload) {
    return this._httpClient.put<void>(this.withBaseUrl(), payload);
  }

  delete(params: IDeleteContactSearchParams) {
    return this._httpClient.delete<void>(this.withBaseUrl(), { params });
  }

  private withBaseUrl(endpoint = "") {
    return `${environment.serverUrl}/contact${endpoint}`;
  }
}
